module.exports = __webpack_public_path__ + "static/media/468x60_0007_ro.3ddac6be.png";